import React, { useState, useEffect } from "react";
import { Navigate } from 'react-router-dom';
import { userService } from "../../_services";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Card, CardContent } from "@/components/ui/card";

export default function FaqPage() {
    const [userData, setUserData] = useState(null);
    const [faqData, setFaqData] = useState([]);

    useEffect(() => {
        // Initialize user data
        try {
            const usermetaData = window.atob(localStorage.getItem('ajs_user_id'));
            setUserData(usermetaData.split(':')[0]);
        } catch (error) {
            console.error('Error loading user data:', error);
        }

        // Load FAQ data
        const showemail = userService.getemail();
        const faqs = [
            {
                question: "Is this really FREE?",
                answer: "Yes absolutely no cost to you now or ever. Not only do other companies pay you less but they charge you an initiation and monthly fee. We think that is outrageous."
            },
            {
                question: "Why is it that agents in the NuLifeSpan Rx Distributor program make more money than anyone else in the industry?",
                answer: "Our goal was to get our discount card spread nationwide. To accomplish that, we have to pay our reps the most in the industry and our card has to provide the greatest discount. We study and research every possible way to get our reps making the most money possible. There are no secrets – you get all the information that our top reps making $10k+ per month get."
            },
            {
                question: "How much money can I make?",
                answer: "You will earn a competitive commission anytime someone uses your card to pick up a prescription."
            },
            {
                question: "How and when do I get paid?",
                answer: "You get paid every month through PayQuicker. You can elect to get a check mailed to you, get direct deposit into your bank account, or have a personal debit card mailed to you that contains your funds. Payments are made monthly for the previous month's transactions."
            },
            {
                question: "Do I have to get NuLifeSpan Rx's approval of my web site or social media posts?",
                answer: "Yes! In order for us to ensure our marketing network complies with all applicable federal, state and local regulations, we require every marketer – and every contractor of every marketer – to submit their marketing materials – which includes, for example, your web site, social media posts, and marketing emails. Failure to do so will subject your contract to immediate termination."
            },
            {
                question: "What if I forget to get pre-approval of my social media or other online posts?",
                answer: "You must immediately delete any such posts (whether inadvertent or not) and submit such inappropriately posted marketing material to <b>NuLifeSpan Rx</b> for review and approval."
            },
            {
                question: "What if one of my subcontractors uses marketing material that they did not submit for pre-approval?",
                answer: "If you learn that one of your contractors has failed to secure pre-approval of their marketing material, you must immediately (1) cause that contractor to cease immediately the use of any such material and (2) report the same to NuLifeSpan Rx – together with the unapproved marketing materials – for review. Any marketer – and any subcontractor of any marketer – is subject to immediate termination for failure to have your marketing material pre-approved by NuLifeSpan Rx."
            },
            {
                question: "What if I have concerns that someone is out there distributing the NuLifeSpan Rx Program in violation of NuLifeSpan Rx's compliance standards?",
                answer: `If you have any such concerns, please contact <a href="mailto:${showemail}">${showemail}</a> immediately so that we can address the situation as soon as possible. If you would prefer to make a confidential, anonymous report, you can use one of these reporting options:<ul><li>Website: <a href="http://www.lighthouse-services.com/rxhacker" target="_blank">www.lighthouse-services.com/rxhacker</a></li><li>Toll-Free Telephone:<ul><li>English speaking: <a href="tel:833-222-2698">833-222-2698</a></li><li>Spanish speaking: <a href="tel:800-216-1288">800-216-1288</a></li></ul></li></ul>`
            },
            {
                question: "What if I have questions about compliance or about what marketing activities I can engage in?",
                answer: `If you have any such questions, please contact your customer success manager, who can direct your questions to the appropriate NuLifeSpan Rx professional. Of course, you can always reach out to <a href="mailto:${showemail}">${showemail}</a> as well.`
            }
        ];

        setFaqData(faqs);
    }, []);

    // Check authentication
    if (userService.Check_Null_Empty(localStorage.getItem("ajs_user_id"))) {
        return <Navigate to="/signup" replace />;
    }

    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-3xl font-bold tracking-tight text-foreground">Frequently Asked Questions</h1>
                <p className="text-muted-foreground mt-2">
                    Hello, welcome and thank you for joining us here at NuLifeSpan Rx! Here we will be addressing some frequently asked questions from our affiliates. Please take the time to read this so you are informed on some of the basics.
                </p>
            </div>

            <Card>
                <CardContent className="pt-6">
                    <Accordion type="single" collapsible className="w-full">
                        {faqData.map((faq, index) => (
                            <AccordionItem key={index} value={`item-${index}`}>
                                <AccordionTrigger className="text-left">
                                    {faq.question}
                                </AccordionTrigger>
                                <AccordionContent>
                                    <div 
                                        className="text-muted-foreground"
                                        dangerouslySetInnerHTML={{ __html: faq.answer }}
                                    />
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </CardContent>
            </Card>
        </div>
    );
}
